// Tour-Schritte für InteractiveTour.js (Phase A Refactoring)
// 1:1 ausgelagert aus components/InteractiveTour.js (reine Daten, keine Closures)

export const mainPageSteps = [
  {
    target: 'body',
    title: 'Willkommen bei BurningTeam! 🎉',
    content: 'Ich zeige Ihnen jetzt die wichtigsten Bereiche Ihrer Business-Plattform. Die Tour dauert nur wenige Minuten!',
    placement: 'center',
    spotlight: false,
  },
  {
    target: '[data-tour="kunden-button"]',
    title: '👥 Kunden-Bereich',
    content: 'Hier verwalten Sie Ihre <strong>Kunden, Teampartner und Kontakte</strong>. Perfekt für bessere Kundenbindung durch Kontakt-Tracking, To-Dos, Abo-Verwaltung und Thematiken im Blick.',
    placement: 'bottom',
    spotlight: true,
    scrollToTop: true,
  },
  {
    target: '[data-tour="zielplanung-button"]',
    title: '📅 Zielplanungs-Kalender',
    content: '<strong>Dein persönlicher Planungsbereich</strong> mit allem, was du brauchst:<br/><br/>🎯 <strong>Zielplanung</strong> – plane deine Ziele vom Jahr bis zur Woche, um sie Schritt für Schritt zu erreichen<br/>📆 <strong>Termine & Kalender</strong> – strukturiere Kundentermine vom Jahresplan bis zur konkreten Woche<br/>✅ <strong>To-dos</strong> – Aufgaben auflisten und abhaken<br/>🔄 <strong>Habit-Tracker</strong> – neue Routinen aufbauen, die dich täglich weiterbringen',
    placement: 'top',
    spotlight: true,
  },
  {
    target: '[data-tour="inventory-button"]',
    title: '📦 Inventar-Bereich',
    content: 'Ihre <strong>komplette Warenverwaltung</strong> mit Lagerbestand, Rechnungen, Geschenken, Eigenverbrauch und Quartalsberichten zum Download.',
    placement: 'top',
    spotlight: true,
    scrollToMainElement: true,
  },
  {
    target: '[data-tour="nachrichten-button"]',
    title: '🔔 Nachrichtencenter',
    content: 'Alle wichtigen <strong>Benachrichtigungen auf einen Blick!</strong><br/><br/>📅 Fällige Termine<br/>🔔 Betreuungs Erinnerungen<br/>🎉 Beförderungen<br/>...und viele weitere wichtige Benachrichtigungen um jeden Tag den Überblick behalten zu können.',
    placement: 'bottom',
    spotlight: true,
  },
  {
    target: '[data-tour="einstellungen-button"]',
    title: '⚙️ Einstellungen',
    content: 'Hier pflegen Sie Ihre <strong>Unternehmensdaten</strong>, die automatisch auf Rechnungen erscheinen.',
    placement: 'bottom',
    spotlight: true,
    showWeiterButton: true,
    scrollToTopInstant: true,
  },
];

// ========== TOUR STEPS FÜR KUNDEN-SEITE ==========
export const kundenSteps = [
  {
    target: 'body',
    title: '👥 Willkommen im Kunden-Bereich!',
    content: 'Hier bauen Sie <strong>langfristige Kundenbeziehungen</strong> auf. Lassen Sie mich Ihnen zeigen, wie Sie einen neuen Kontakt erstellen!',
    placement: 'center',
    spotlight: false,
  },
  {
    target: '[data-tour="kontakt-hinzufuegen-button"]',
    title: '➕ Beispiel-Kontakt erstellen',
    content: 'Lassen Sie uns gemeinsam einen <strong>Beispiel-Kontakt</strong> erstellen! Klicken Sie auf diesen Button, um das Formular zu öffnen. Dieser Kontakt kann später wieder gelöscht werden.',
    placement: 'bottom',
    spotlight: true,
    requireClick: true,
  },
  {
    target: '[data-field="name"]',
    title: '📝 Schritt 1: Voller Name',
    content: 'Tragen Sie hier den <strong>vollständigen Namen</strong> des Kontakts ein. Zum Beispiel: "Max Mustermann"',
    placement: 'bottom',
    spotlight: true,
    scrollToField: true,
    requireInput: true,
    hideBackButton: true,
  },
  {
    target: '[data-field="typ"]',
    title: '🏷️ Schritt 2: Kontakt-Typ',
    content: 'Das Feld <strong>"Typ"</strong> ist zur Schnell-Auswahl gedacht:<br/><br/>• <strong>Neuer Kontakt</strong>: Für erste Interessenten<br/>• <strong>Teampartner</strong>: Aktive Partner<br/>• <strong>Kunde</strong>: Bestehende Kunden<br/><br/>Für diese Erklärung überspringen wir die Auswahl.',
    placement: 'bottom',
    spotlight: true,
    scrollToField: true,
  },
  {
    target: '[data-field="naechster-termin"]',
    title: '📅 Schritt 3: Termin planen',
    content: 'Hier tragen Sie ein, wann Sie planen, mit dem neuen Kontakt einen Termin auszumachen. Dies hilft Ihnen, den Überblick zu behalten. Wir überspringen dieses Feld für jetzt.',
    placement: 'bottom',
    spotlight: true,
    scrollToField: true,
    blockClicks: true,
  },
  {
    target: '[data-field="kontaktiert"]',
    title: '✅ Schritt 4: Kontaktiert',
    content: 'Wenn Sie einen <strong>Termin mit dem Kontakt ausgemacht</strong> haben, klicken Sie hier auf <strong>"Ja"</strong>. Dies markiert den Kontakt als erfolgreich kontaktiert.<br/><br/>👉 <strong>Klicken Sie jetzt auf "Ja"!</strong>',
    placement: 'bottom',
    spotlight: true,
    scrollToField: true,
    requireClick: true,
    waitForElement: '[data-field="kontaktiert"][data-value="true"]',
    spotlightPadding: 10,
  },
  {
    target: '[data-field="naechster-termin"]',
    title: '📅 Schritt 5: Termin-Assistent öffnen',
    content: 'Jetzt tragen wir den Termin ein! Ein Klick öffnet den <strong>Termin-Assistenten</strong> – er führt Sie Schritt für Schritt durch Datum, Uhrzeit und mehr.<br/><br/>👉 <strong>Klicken Sie auf den Button!</strong>',
    placement: 'bottom',
    spotlight: true,
    scrollToField: true,
    scrollOffset: -180,
    requireClick: true,
  },
  {
    target: '[data-tour="termin-wizard-datum-feld"]',
    title: '📅 Termin-Assistent: Datum',
    content: 'Der Assistent ist geöffnet!<br/><br/>👉 <strong>Geben Sie das heutige Datum ein.</strong><br/><br/>💡 Am Ende trägt der Assistent den Termin in Ihren Kalender ein – er erscheint dort, sobald Sie den Kontakt gespeichert haben.',
    placement: 'bottom',
    spotlight: true,
    requireInput: true,
    hideBackButton: true,
  },
  {
    target: '[data-tour="termin-wizard-uhrzeit-feld"]',
    title: '⏰ Termin-Assistent: Uhrzeit',
    content: '👉 Tragen Sie <strong>Von-</strong> und <strong>Bis-Uhrzeit</strong> ein.<br/><br/>💡 <strong>Kalender-Vorschau:</strong> Gibt einen schnellen Überblick über Ihre bestehenden Termine.<br/><br/>Danach klicken Sie auf <strong>"Weiter →"</strong>.',
    placement: 'top',
    multiSpotlight: ['[data-tour="termin-wizard-uhrzeit-feld"]', '[data-tour="termin-wizard-weiter-btn"]'],
    requireClick: true,
  },
  {
    target: '[data-tour="termin-wizard-zuletzt-kontaktiert"]',
    title: '📞 Zuletzt kontaktiert',
    content: 'Mit diesem Feld verhindern Sie den Kontaktverlust zu Ihren Kunden.<br/><br/>Zur Schnellauswahl stehen drei Optionen bereit:<br/>• <strong>Heute</strong> – wenn Sie heute Kontakt hatten<br/>• <strong>Anderes Datum</strong> – für einen individuellen Zeitpunkt<br/>• <strong>Nicht aktualisieren</strong> – falls noch kein Kontakt stattfand oder Sie es nicht dokumentieren möchten<br/><br/>Klicken Sie auf <strong>"Weiter"</strong> um fortzufahren.',
    placement: 'top',
    spotlight: false,
    showBackground: true,
    disableManualScroll: true,
  },
  {
    target: '[data-tour="termin-wizard-zuletzt-kontaktiert"]',
    title: '📞 Zuletzt kontaktiert',
    content: 'Wählen Sie jetzt <strong>"Anderes Datum"</strong> und geben Sie ein Datum ein, das <strong>mehr als 3 Monate zurückliegt</strong> – so können Sie die automatische Erinnerungsfunktion testen.<br/><br/>Danach klicken Sie auf <strong>"Weiter →"</strong>.',
    placement: 'top',
    multiSpotlight: ['[data-tour="termin-wizard-anderes-datum"]', '[data-tour="termin-wizard-zuletzt-weiter"]'],
    requireClick: true,
    disableManualScroll: true,
  },
  {
    target: '[data-tour="termin-wizard-gespraechsverlauf"]',
    title: '💬 Gesprächsverlauf',
    content: '👉 Klicken Sie auf <strong>"Weiter →"</strong>.',
    placement: 'top',
    spotlight: false,
    showBackground: true,
    compactModal: true,
    requireClick: true,
    disableManualScroll: true,
  },
  {
    target: '[data-tour="termin-wizard-naechstes-thema"]',
    title: '📋 Nächstes Thema',
    content: 'Was ist das Thema für den nächsten Termin? Wenn alles eingetragen ist, klicken Sie auf <strong>"Fertig ✓"</strong>.',
    placement: 'top',
    multiSpotlight: ['[data-tour="termin-wizard-naechstes-thema-input"]', '[data-tour="termin-wizard-fertig-btn"]'],
    requireClick: true,
    disableManualScroll: true,
  },
  {
    target: '[data-field="tp-kunde-geworden"]',
    title: '🎯 Schritt 7: Beförderung',
    content: 'Wenn der Termin gut gelaufen ist, können Sie den Kontakt zum <strong>Teampartner</strong> oder <strong>Kunden</strong> befördern!<br/><br/>👉 <strong>Wählen Sie "✅ Teampartner"!</strong>',
    placement: 'bottom',
    spotlight: true,
    scrollToField: true,
    requireClick: true,
    waitForElement: '[data-field="tp-kunde-geworden"][data-value="teampartner"]',
  },
  {
    target: '[data-field="linie"]',
    title: '📊 Schritt 8: Linie',
    content: 'Hier können Sie auswählen, ob der Teampartner/Kunde <strong>Erstlinie</strong> ist oder bei jemand anderem <strong>untergeordnet</strong> ist.',
    placement: 'bottom',
    spotlight: true,
    scrollToField: true,
    fastScroll: true,
    blockClicks: true,
  },
  {
    target: '[data-field="notizen-aufgaben-gruppe"]',
    title: '📝 Schritt 9: Noch zu erledigen & Notizen',
    content: 'Hier können Sie <strong>Notizen</strong> und <strong>offene Aufgaben</strong> zum Kontakt speichern.<br/><br/>💡 Aufgaben lassen sich auch direkt im <strong>Kalender</strong> einplanen!',
    placement: 'bottom',
    spotlight: true,
    scrollToField: true,
    blockClicks: true,
  },
  {
    target: '[data-field="thematik-produkte"]',
    title: '🏷️ Schritt 10: Thematik & Produkte',
    content: '<div class="text-xs">Dokumentieren Sie folgende Informationen des Kontakts:<br/>• Thematiken<br/>• Produkte im Abo und Empfehlungs Ideen<br/>• Veranstaltungen<br/><br/>Die Listen können über "⚙️ Liste bearbeiten" angepasst werden!</div>',
    placement: 'top',
    spotlight: true,
    scrollToField: true,
    scrollOffset: -100,
  },
  {
    target: '[data-field="einschreibedatum"]',
    title: '📅 Schritt 11: Betreuungssystem',
    content: 'Hier sehen Sie, <strong>wann der Kontakt zum Teampartner befördert wurde</strong> und <strong>wann das nächste Paket kommt</strong>. Das Beförderungsdatum wird automatisch am Tag des Eintrags zum Teampartner gesetzt.',
    placement: 'top',
    spotlight: true,
    scrollToField: true,
    fastScroll: true,
    scrollOffset: -250,
  },
  {
    target: '[data-field="followups"]',
    title: '📞 Schritt 12: Follow Ups',
    content: 'Hier sehen Sie <strong>Follow Ups</strong>, also die <strong>Kundenbetreuungsschritte</strong>, vom Starttag (Beförderungstag) beginnend. Sie können die Kundenbetreuung aktualisieren und werden nach Ablauf der Zeit im <strong>Nachrichtencenter erinnert</strong>, um den Überblick nicht zu verlieren.',
    placement: 'bottom',
    spotlight: true,
    scrollToField: true,
  },
  {
    target: '[data-field="cellreset"]',
    title: '🧬 Schritt 13: Cellreset',
    content: 'Hier können Sie auswählen, ob <strong>Cellreset gemacht wurde</strong>, ob es <strong>richtig gemacht wurde</strong> und ob <strong>Interesse</strong> besteht, es zu machen.',
    placement: 'bottom',
    spotlight: true,
    scrollToField: true,
  },
  {
    target: '[data-field="actionpack"]',
    title: '📦 Schritt 14: Actionpack',
    content: 'Hier tragen Sie ein, ob das <strong>Actionpack schon genommen wurde</strong> oder ob <strong>Interesse</strong> besteht.',
    placement: 'bottom',
    spotlight: true,
    scrollToField: true,
  },
  {
    target: '[data-tour="speichern-button"]',
    title: '💾 Schritt 15: Speichern',
    content: 'Klicken Sie jetzt auf <strong>"Erstellen"</strong>, um den Beispiel-Kontakt zu speichern!<br/><br/>👉 <strong>Klicken Sie auf den Button!</strong>',
    placement: 'top',
    spotlight: true,
    requireClick: true,
  },
  {
    target: 'body',
    title: '🎉 Fast geschafft!',
    content: 'Gleich erscheint ein <strong>Herzlich Willkommen-Modal</strong>.<br/><br/>👉 <strong>Klicken Sie auf "Weiter geht\'s!"</strong>',
    placement: 'top-small',
    spotlight: false,
    waitForModal: true,
    showBackground: true,
    noWeiterButton: true,
  },
  {
    target: '[data-tour="kachel-expand-button"]',
    title: '🎴 Schritt 17: Kontakt-Kachel',
    content: 'Super! Hier ist die Kachel Ihres neuen Teampartners.<br/><br/>👇 <strong>Klicken Sie jetzt auf den Pfeil</strong> rechts oben in der Kachel, um alle Details auszuklappen!',
    placement: 'top',
    spotlight: true,
    requireClick: true,
    waitForCard: true,
    forceScrollTop: true,
  },
  {
    target: '[data-tour="naechster-termin-kachel"]',
    title: '📅 Schritt 18: Nächster Termin - Farblogik',
    content: '<div class="text-sm">Das Feld <strong>"Nächster Termin"</strong> zeigt farblich an, wann der nächste Termin ansteht:<br/><br/>🔴 <strong>Rot</strong>: Termin ist <strong>heute oder überfällig</strong> – sofortige Aktion erforderlich!<br/>🟠 <strong>Orange</strong>: Termin ist in den <strong>nächsten 3 Tagen</strong> – bald kümmern!<br/>🟢 <strong>Grün</strong>: Termin liegt <strong>weiter in der Zukunft</strong> – alles im grünen Bereich.<br/><br/>💡 <strong>Tipp:</strong> Überfällige Termine werden auch im <strong>Nachrichtencenter</strong> angezeigt!</div>',
    placement: 'top',
    spotlight: true,
    scrollToField: true,
    scrollOffset: -350,
  },
  {
    target: '[data-tour="letzter-termin-kachel"]',
    title: '📞 Schritt 19: Zuletzt Kontaktiert - Farblogik',
    content: '<div class="text-sm">Das Feld <strong>"Zuletzt Kontaktiert"</strong> zeigt farblich an, wie lange der letzte Kontakt her ist:<br/><br/>🔴 <strong>Rot</strong>: Letzter Kontakt ist <strong>über 30 Tage her</strong> – dringend melden!<br/>🟠 <strong>Orange</strong>: Letzter Kontakt ist <strong>14-30 Tage her</strong> – bald wieder kontaktieren!<br/>🟢 <strong>Grün</strong>: Letzter Kontakt ist <strong>weniger als 14 Tage her</strong> – gute Betreuung!<br/><br/>💡 <strong>Tipp:</strong> In den Einstellungen kann der Zeitraum für Kontaktverlust angepasst werden.</div>',
    placement: 'top',
    spotlight: true,
    scrollToField: true,
    scrollOffset: -350,
  },
  {
    target: '[data-tour="tab-suche"]',
    title: '🔍 Schritt 20: Suche & Filter',
    content: 'Im Tab <strong>"Suche"</strong> können Sie Ihre Kontakte, Teampartner und Kunden ganz einfach filtern und finden – besonders praktisch, wenn Sie viele davon haben. Und das werden Sie mit der Unterstützung dieser App definitiv schaffen! 🚀💪',
    placement: 'bottom',
    spotlight: true,
    scrollToTop: true,
  },
  {
    target: '[data-tour="tab-schulden"]',
    title: '💰 Schritt 21: Schulden verwalten',
    content: '👉 <strong>Klicken Sie jetzt auf "Schulden"</strong>, um mehr zu erfahren!',
    placement: 'bottom',
    spotlight: true,
    requireClick: true,
    scrollToTop: true,
  },
  {
    target: 'body',
    title: '💰 Schulden-Verwaltung',
    content: '<div class="text-sm">Hier können Sie <strong>Kontakt-Schulden</strong> und <strong>private Schulden</strong> eintragen, um eine bessere Übersicht zu behalten.<br/><br/>✨ <strong>Features:</strong><br/>• Schulden mit Kontakten verknüpfen<br/>• Zuschlag-Funktion (optional, einfach 0% eintragen wenn nicht benötigt)<br/>• Vergangene Schulden sind hier ersichtlich<br/><br/>Schulden, die mit einem Kontakt verknüpft sind, werden beim jeweiligen Kontakt angezeigt.</div>',
    placement: 'center',
    spotlight: false,
  },
  {
    target: 'body',
    title: '🎉 Herzlichen Glückwunsch!',
    content: 'Sie haben das <strong>Kunden-Onboarding</strong> erfolgreich abgeschlossen! 🎊<br/><br/>Sie kennen jetzt alle wichtigen Funktionen. Der erstellte Kontakt kann jederzeit wieder gelöscht werden.<br/><br/>Möchten Sie mit einer weiteren Tour fortfahren oder die Tour beenden?',
    placement: 'center',
    spotlight: false,
    showKundenFinalChoice: true,
  },
];

// ========== TOUR STEPS FÜR INVENTORY-SEITE ==========
export const inventorySteps = [
  {
    target: 'body',
    title: '📦 Willkommen zur Inventory-Tour!',
    content: 'Hier verwalten Sie Ihren <strong>Bestand und Rechnungen</strong> professionell und übersichtlich.<br/><br/>Nutzen Sie die <strong>Analysen</strong>, um sich Schritt für Schritt zu verbessern. Die Einträge können sowohl von Ihnen als auch von Ihrem Partner unter "Haushalt" erfasst werden – so haben Sie <strong>immer und überall</strong> den perfekten Überblick über Ihren Bestand!',
    placement: 'center',
    spotlight: false,
  },
  {
    target: '[data-tour="produktliste-button"]',
    title: '📋 Schritt 1: Preisliste',
    content: 'Hier werden <strong>alle verfügbaren Produkte</strong> übersichtlich gelistet – mit <strong>Preiskategorien</strong>, <strong>Punkten</strong> und <strong>Steuersätzen</strong>. So haben Sie Ihre Produktpalette immer im Blick!',
    placement: 'top',
    spotlight: true,
    blockClicks: true,
    scrollToElement: true,
    scrollOffset: 200,
  },
  {
    target: '[data-tour="eingangsliste-button"]',
    title: '📥 Schritt 2: Eingangsliste',
    content: 'In der <strong>Eingangsliste</strong> tragen Sie ein, <strong>wann welche Produkte eingekauft wurden</strong>. So behalten Sie immer den Überblick über Ihre Wareneingänge und können Ihren Bestand optimal verwalten.<br/><br/>👉 <strong>Klicken Sie jetzt auf "Eingangsliste"!</strong>',
    placement: 'top',
    spotlight: true,
    requireClick: true,
    scrollToTop: true,
  },
];

// ========== TOUR STEPS FÜR EINGANGSLISTE-SEITE ==========
export const eingangslisteSteps = [
  {
    target: '[data-tour="eingang-hinzufuegen-button"]',
    title: '➕ Eingang hinzufügen',
    content: 'Klicken Sie auf <strong>"Eingang hinzufügen"</strong>, um einen neuen Wareneingang zu erfassen.<br/><br/>👉 <strong>Klicken Sie auf den Button!</strong>',
    placement: 'bottom',
    spotlight: true,
    requireClick: true,
    scrollToTop: true,
  },
  {
    target: 'body',
    title: '📝 Formular erklärt',
    content: '<div class="text-sm">Das Eingangs-Formular enthält:<br/><br/>• <strong>Artikel</strong>: Alle Produkte aus der Preisliste<br/>• <strong>Preiskategorie</strong>: Zu welchem Preis wurde eingekauft (TP, Kunde, BA, etc.)<br/>• <strong>Datum & Menge</strong>: Wann und wie viel eingekauft wurde<br/><br/>Klicken Sie auf <strong>"Weiter"</strong>, um ein Produkt hinzuzufügen.</div>',
    placement: 'center',
    spotlight: false,
  },
  {
    target: '[data-tour="eingang-formular"]',
    title: '➕ Produkt hinzufügen',
    content: 'Artikel wählen → Speichern',
    placement: 'top-start',
    placementFixed: true,
    spotlight: true,
    allowScrollInSpotlight: true,
    allowUserScroll: true,
    requireFormSubmit: true,
    compactModal: true,
  },
  {
    target: '[data-tour="quartal-eintrag"]',
    title: '✅ Eintrag gespeichert!',
    content: 'Ihr Eintrag ist jetzt im Quartal sichtbar. Sie können den Quartalsreport als PDF exportieren oder Einträge wieder löschen.',
    placement: 'top-start',
    placementFixed: true,
    spotlight: true,
    blockClicks: true,
    waitForElement: true,
    scrollToElement: true,
    scrollOffset: 1000,
    compactModal: true,
  },
  {
    target: '[data-tour="filter-tabs"]',
    title: '🔍 Filter-Optionen',
    content: 'Oben können Sie <strong>filtern</strong> nach:<br/><br/>• <strong>Geschäftlich</strong>: Geschäftliche Einkäufe<br/>• <strong>Haushalt</strong>: Lebenspartner-Einkäufe<br/>• <strong>Gesamt</strong>: Alle Einträge zusammen',
    placement: 'bottom',
    spotlight: true,
    blockClicks: true,
    scrollToTop: true,
  },
  {
    target: '[data-tour="zurueck-button"]',
    title: '🔙 Zurück zu Inventory',
    content: 'Die Eingangsliste ist nun erklärt!<br/><br/>👉 <strong>Klicken Sie auf "Zurück zu Inventory"</strong>',
    placement: 'bottom',
    spotlight: true,
    scrollToTop: true,
    requireBackNavigation: true,
  },
];

// ========== TOUR STEPS FÜR INVENTORY-DASHBOARD (nach Eingangsliste) ==========
export const inventoryBestandSteps = [
  {
    target: '[data-tour="bestand-button"]',
    title: '📊 Jetzt Bestand öffnen',
    content: '👉 <strong>Klicken Sie auf "Bestand"</strong>, um Ihre Bestandsübersicht zu sehen.',
    placement: 'top',
    spotlight: true,
    scrollToElement: true,
    scrollOffset: 200,
    requireClickBestand: true,
  },
];

// ========== TOUR STEPS FÜR ÜBERSICHT/BESTAND-SEITE ==========
export const uebersichtSteps = [
  {
    target: '[data-tour="bestand-tabelle"]',
    title: '📊 Bestandsübersicht',
    content: '<div class="text-sm">Hier sehen Sie Ihren <strong>gesamten Bestand</strong> auf einen Blick:<br/><br/>• Produkte sortiert nach <strong>Menge</strong><br/>• <strong>Ø EK-Preis</strong>: Durchschnittlicher Einkaufspreis<br/>• <strong>Zugänge</strong>: Eingangsliste-Einträge<br/>• <strong>Abflüsse</strong>: Verkäufe, Geschenke, Werbung, Demos, Eigenverbrauch</div>',
    placement: 'bottom',
    spotlight: true,
    spotlightPadding: 8,
    autoScrollTable: true, // Custom flag für Mobile Auto-Scroll
  },
  {
    target: '[data-tour="bestand-tabelle"]',
    title: '🎯 Demo-Produkte (Vorführartikel)',
    content: '<div class="text-sm">Bei <strong>Vorführartikeln</strong> wird <strong>1 Stück</strong> vom Bestand abgezogen.<br/><br/>Bei <strong>Demos</strong> wird 1 Artikel angezeigt, der angefangen wurde. Der verbleibende <strong>Prozentanteil</strong> wird in der <strong>Demo %</strong> Spalte angezeigt.</div>',
    placement: 'bottom',
    spotlight: true,
    spotlightPadding: 8,
    highlightDemoColumns: true,
  },
  {
    target: '[data-tour="zurueck-dashboard-button"]',
    title: '🔙 Zurück zum Dashboard',
    content: '👉 <strong>Klicken Sie auf "Zurück"</strong>, um zum Dashboard zurückzukehren.',
    placement: 'bottom',
    spotlight: true,
    scrollToTop: true,
    requireNavigateToDashboardForGeschenk: true,
  },
];

// ========== TOUR STEPS FÜR GESCHENK-ERKLÄRUNG AUF DASHBOARD ==========
export const geschenkSteps = [
  {
    target: '[data-tour="geschenke-button"]',
    title: '🎁 Geschenke (geschäftlich)',
    content: '<div class="text-sm">Produkte aus <strong>Dank oder Wertschätzung</strong> an bestimmte Personen verschenken.<br/><br/><strong>Beispiel:</strong> Dose als Dankeschön an treue Kundin.<br/><br/>📄 Quartalsreports als Download möglich.</div>',
    placement: 'top-fixed',
    spotlight: true,
    scrollToTargetWithModalOffset: true,
    blockClicks: true,
  },
  {
    target: '[data-tour="werbeartikel-button"]',
    title: '📢 Werbung / Werbemaßnahme',
    content: '<div class="text-sm">Produkte weitergeben, damit andere sie <strong>kennenlernen oder testen</strong> können.<br/><br/><strong>Beispiel:</strong> Dose als Probe an Interessenten verschenken.<br/><br/>📄 Quartalsreports als Download möglich.</div>',
    placement: 'top-fixed',
    spotlight: true,
    scrollToTargetWithModalOffset: true,
    blockClicks: true,
  },
  {
    target: '[data-tour="vorfuehrartikel-button"]',
    title: '🎪 Demo / Muster / Eigenwerbung',
    content: '<div class="text-sm">Produkte selbst bei <strong>Vorführungen, Infoabenden oder Verkostungen</strong> einsetzen.<br/><br/><strong>Beispiel:</strong> Dose öffnen und bei Präsentation probieren lassen.<br/><br/>📄 Quartalsreports als Download möglich.</div>',
    placement: 'top-fixed',
    spotlight: true,
    scrollToTargetWithModalOffset: true,
    blockClicks: true,
  },
  {
    target: '[data-tour="rechnungen-button"]',
    title: '🧾 Rechnungen erstellen',
    content: '<div class="text-sm">Erstellen Sie <strong>Rechnungen</strong> für Ihre Verkäufe. Das System unterscheidet automatisch zwischen Kleinbetragsrechnungen und Rechnungen über 250€.<br/><br/>💡 Rechnungen können zu Kundenschulden hinzugefügt werden.<br/><br/>⚠️ <strong>Wichtiger Hinweis:</strong> Es wird empfohlen, dass Teampartner <strong>eigenständig bestellen</strong>, da dies aus geschäftlicher Sicht vorteilhafter ist. Die erstellten Rechnungen dienen ausschließlich als Hilfsmittel, sind <strong>ohne Gewähr</strong> und stellen <strong>keine steuerliche Beratung</strong> dar.</div>',
    placement: 'top-fixed',
    spotlight: true,
    scrollToTop: true,
    blockClicks: true,
  },
  {
    target: '[data-tour="quartalsuebersicht-button"]',
    title: '📊 Quartalsübersicht',
    content: '<div class="text-sm">Übersicht über <strong>Zugänge, Abgänge und Differenzen</strong> pro Quartal.<br/><br/>⚠️ <strong>Hinweis:</strong> Alle angezeigten Daten dienen der Orientierung und sind <strong>ohne Gewähr</strong>. Eine eigenständige Überprüfung der Werte wird empfohlen.</div>',
    placement: 'top-fixed',
    spotlight: true,
    scrollToTargetWithModalOffset: true,
    blockClicks: true,
  },
  {
    target: '[data-tour="analyse-button"]',
    title: '📈 Analysen & Auswertungen',
    content: '<div class="text-sm">Detaillierte <strong>Umsatz- und Verkaufsanalysen</strong> mit Diagrammen:<br/><br/>• Top-Artikel nach Verkäufen<br/>• Zeitliche Entwicklung (Quartal/Jahr)<br/>• Zugänge vs. Abgänge<br/>• Punkte-Übersicht<br/><br/>⚠️ <strong>Hinweis:</strong> Alle Auswertungen dienen der Orientierung und sind <strong>ohne Gewähr auf Richtigkeit</strong>.</div>',
    placement: 'top-fixed',
    spotlight: true,
    scrollToTargetWithModalOffset: true,
    blockClicks: true,
  },
  {
    target: 'body',
    title: '🎉 Inventory-Tour abgeschlossen!',
    content: '<div class="text-sm mb-4">Sie haben die <strong>Inventory-Tour</strong> erfolgreich abgeschlossen!<br/><br/>Sie wissen jetzt, wie Sie:<br/>• Wareneingänge erfassen<br/>• Ihren Bestand überwachen<br/>• Geschenke, Werbung & Demos verwalten<br/>• Rechnungen erstellen<br/>• Analysen nutzen</div><div class="border-t pt-3 mt-3"><p class="font-semibold text-gray-700 mb-2">Möchten Sie fortfahren?</p></div>',
    placement: 'center',
    spotlight: false,
    showKundenTourChoice: true,
  },
];
